type RoundedIconProps = {
  icon: React.ReactNode;
  bgColor?: string;
  className?: string;
  onClick?: () => void;
};

const RoundedIcon = ({
  icon,
  bgColor,
  className,
  onClick,
}: RoundedIconProps) => {
  return (
    <div
      className={`flex size-9 items-center justify-center rounded-full ${bgColor} border border-white/30 ${className}`}
      onClick={onClick}
    >
      {icon}
    </div>
  );
};

export default RoundedIcon;
